import React, { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import UserContext from '../../context/UserContext.js';
import FiltrosClubes from './FiltrosClubes.js';
import NuevoClubFiltro from './NuevoClubFiltro.js';
import RecuadroArgentina from './RecuadroArgentina.js';
import PanelAgregarResponsive from '../UI/PanelAgregarResponsive.js';
import { TituloPagina } from '../funciones/Funciones.js';
import * as FuncionesFecha from '../funciones/FuncionesFecha.js';
import * as FuncionesOrdenamiento from './FuncionesOrdenamientoClubes.js';
import styles from './BaseClubes.module.css';

const BaseClubes = (props) => {
  const [searchParameters] = useSearchParams();
  const [lista, setLista] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [ordenPor, setOrdenPor] = useState(FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE);
  const [ascendente, setAscendente] = useState(true);
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;

  useEffect(() => {
    document.title = TituloPagina(BaseClubes.name);
  }, []);

  const onBuscando = () => {
    setLista([]);
    setBuscando(true);
  };

  const onListaCargada = (clubes) => {
    setBuscando(false);
    setLista(clubes);
  };

  return (
    <div className={`${styles.baseClubes}`}>
      <FiltrosClubes
        searchParams={searchParameters}
        onBuscando={onBuscando}
        onListaCargada={onListaCargada}
        initialCollapsed={true}
        hasResults={lista && lista.length > 0}
      />
      {lista === null && !buscando && <RecuadroArgentina />}
      <PanelAgregarResponsive
        Componente={NuevoClubFiltro}
        objeto="club"
        lista={lista}
        onListaCargada={onListaCargada}
        puedeEditar={puedeEditar}
        buscando={buscando}
      >
        {!buscando && lista && lista.length === 0 && (
          <div className={`${styles.mensajeSinDatos}`}>No se encontraron clubes</div>
        )}
        {lista && lista.length > 0 && (
          <React.Fragment>
            <table className={`${styles.tablaClubes}`}>
              <tbody>
                <tr className={`${styles.filaTitulos}`}>
                  <td
                    width="35%"
                    className={styles.columnaTitulo}
                    onClick={() => {
                      if (ordenPor === FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE) {
                        setAscendente(!ascendente);
                      } else {
                        setOrdenPor(FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE);
                        setAscendente(true);
                      }
                    }}
                    title="Click para ordenar por nombre"
                  >
                    <strong>
                      Nombre
                      <span className={`${styles.iconoOrdenamiento}`}>
                        {ordenPor === FuncionesOrdenamiento.CamposOrdenamiento.NOMBRE
                          ? ascendente
                            ? ' ▲'
                            : ' ▼'
                          : ''}
                      </span>
                    </strong>
                  </td>
                  <td
                    width="20%"
                    className={styles.columnaTitulo}
                    onClick={() => {
                      if (ordenPor === FuncionesOrdenamiento.CamposOrdenamiento.PAIS) {
                        setAscendente(!ascendente);
                      } else {
                        setOrdenPor(FuncionesOrdenamiento.CamposOrdenamiento.PAIS);
                        setAscendente(true);
                      }
                    }}
                    title="Click para ordenar por país"
                  >
                    <strong>
                      País
                      <span className={`${styles.iconoOrdenamiento}`}>
                        {ordenPor === FuncionesOrdenamiento.CamposOrdenamiento.PAIS
                          ? ascendente
                            ? ' ▲'
                            : ' ▼'
                          : ''}
                      </span>
                    </strong>
                  </td>
                  <td
                    width="20%"
                    className={styles.columnaTitulo}
                    onClick={() => {
                      if (ordenPor === FuncionesOrdenamiento.CamposOrdenamiento.LOCALIDAD) {
                        setAscendente(!ascendente);
                      } else {
                        setOrdenPor(FuncionesOrdenamiento.CamposOrdenamiento.LOCALIDAD);
                        setAscendente(true);
                      }
                    }}
                    title="Click para ordenar por localidad"
                  >
                    <strong>
                      Localidad
                      <span className={`${styles.iconoOrdenamiento}`}>
                        {ordenPor === FuncionesOrdenamiento.CamposOrdenamiento.LOCALIDAD
                          ? ascendente
                            ? ' ▲'
                            : ' ▼'
                          : ''}
                      </span>
                    </strong>
                  </td>
                  <td
                    width="15%"
                    className={styles.columnaTitulo}
                    onClick={() => {
                      if (ordenPor === FuncionesOrdenamiento.CamposOrdenamiento.FUNDACION) {
                        setAscendente(!ascendente);
                      } else {
                        setOrdenPor(FuncionesOrdenamiento.CamposOrdenamiento.FUNDACION);
                        setAscendente(true);
                      }
                    }}
                    title="Click para ordenar por fundación"
                  >
                    <strong>
                      Fundación
                      <span className={`${styles.iconoOrdenamiento}`}>
                        {ordenPor === FuncionesOrdenamiento.CamposOrdenamiento.FUNDACION
                          ? ascendente
                            ? ' ▲'
                            : ' ▼'
                          : ''}
                      </span>
                    </strong>
                  </td>
                </tr>
                {FuncionesOrdenamiento.ordenarClubes(lista, ordenPor, ascendente).map((club) => {
                  return (
                    <tr key={club.id} className={`${styles.filaClub}`}>
                      <td>
                        <Link to={'/club/' + club.id}>{club.nombre}</Link>
                      </td>
                      <td>{club.pais && club.pais.nombre}</td>
                      <td>{club.localidad && club.localidad.nombre}</td>
                      <td>
                        {FuncionesFecha.CamposToFechaCorta(
                          club.anioFundacion,
                          club.mesFundacion,
                          club.diaFundacion
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </React.Fragment>
        )}
      </PanelAgregarResponsive>
    </div>
  );
};

export default BaseClubes;
